import { format, startOfWeek, differenceInCalendarDays, differenceInCalendarWeeks, differenceInYears, isYesterday, isToday } from 'date-fns';
import type { AgeGroup } from '../types/child';

export function todayStr(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

export function formatDate(date: string): string {
  return format(new Date(date + 'T00:00:00'), 'EEEE, MMMM d');
}

export function getDayOfWeek(date: string): number {
  return new Date(date + 'T00:00:00').getDay();
}

export function getWeekNumber(startDate: string, currentDate: string): number {
  const start = new Date(startDate + 'T00:00:00');
  const current = new Date(currentDate + 'T00:00:00');
  return differenceInCalendarWeeks(current, startOfWeek(start));
}

export function daysSince(dateStr: string | null): number {
  if (!dateStr) return Infinity;
  return differenceInCalendarDays(new Date(), new Date(dateStr + 'T00:00:00'));
}

export function wasYesterday(dateStr: string | null): boolean {
  if (!dateStr) return false;
  return isYesterday(new Date(dateStr + 'T00:00:00'));
}

export function isDateToday(dateStr: string | null): boolean {
  if (!dateStr) return false;
  return isToday(new Date(dateStr + 'T00:00:00'));
}

export function ageGroupFromBirthDate(birthDate: string): AgeGroup {
  const age = differenceInYears(new Date(), new Date(birthDate + 'T00:00:00'));
  if (age <= 4) return 'pre-k';
  if (age <= 6) return 'kinder';
  if (age <= 8) return 'early-elementary';
  return 'upper-elementary';
}

export function ageFromBirthDate(birthDate: string): number {
  return differenceInYears(new Date(), new Date(birthDate + 'T00:00:00'));
}
